export default "__VITE_ASSET__CC8TlaWU__"